// Admin DashboardPage — 4 KPI cards + enrollments-by-month chart.
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useFetch } from "../../hooks/useApi.js";
import StatCard from "../../components/shared/StatCard.js";
import type { AdminSnapshot } from "@dm-lms/shared/types";

export default function DashboardPage() {
  const { data, isLoading, error } = useFetch<AdminSnapshot>("/api/admin/snapshot");

  return (
    <div className="dm-page">
      <h1 className="text-2xl font-semibold text-dm-navy mb-6">Admin Dashboard</h1>

      {isLoading && <p className="text-dm-slate text-sm">Loading snapshot…</p>}
      {error && <p className="text-red-600 text-sm">{error}</p>}

      {data && (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
            <StatCard label="Total Students" value={data.totalStudents} />
            <StatCard label="Total Revenue (KES)" value={data.totalRevenueKes.toLocaleString()} />
            <StatCard label="Active Courses" value={data.publishedCourses} />
            <StatCard label="Pending Certificates" value={data.pendingCertificates} />
          </div>

          <h2 className="text-lg font-medium text-dm-navy mb-3">Enrollments by Month</h2>
          {data.enrollmentsByMonth.length === 0 ? (
            <p className="text-dm-slate text-sm">No enrollment activity yet.</p>
          ) : (
            <div className="rounded-lg border border-gray-200 bg-white p-4" style={{ height: 300 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={data.enrollmentsByMonth}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                  <XAxis dataKey="month" stroke="#5A5F6B" fontSize={12} />
                  <YAxis allowDecimals={false} stroke="#5A5F6B" fontSize={12} />
                  <Tooltip />
                  <Bar dataKey="count" name="Enrollments" fill="#0B2C63" radius={[4, 4, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          )}
        </>
      )}
    </div>
  );
}
